exports.install = function (Vue, options) {
	//获取录像机列表
	Vue.prototype.getvcr = function(value={})
	{
		if(value.qaedas_id==null)
		{
			value.qaedas_id=this.getCookie(this.config.jdid);
		}
		return this.axiosget("/api/vcr/getList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('vcr',response.data.data.list);
			}
		})
	};
	//添加录像机
	Vue.prototype.addvcr = function(value)
	{
		value.qaedas_id=this.getCookie(this.config.jdid);
		return this.axiospost("/api/vcr/add",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getvcr();
			}
			return response;
		});
	};
	//修改录像机
	Vue.prototype.editvcr = function(value)
	{
		return this.axiospost("/api/vcr/update",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getvcr();
			}
			return response;
		});
	};
	//删除录像机
	Vue.prototype.delvcr = function(value)
	{
		this.axiospost("/api/vcr/delete",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getvcr();
			}
			return response;
		});
	};
	//启动暂停录像机
	Vue.prototype.startpause = function(value)
	{
		this.axiospost("/api/vcr/startPause",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getvcr();
			}
			return response;
		});
	};
}